import {COMPONENT_TYPES} from 'containers/WisbitPage/constants';

const Microlearning = {
  id: 'micro-learning',
  name: 'Microlearning',
  time: '5 - 10 minuten',
  descriptions: ['Korte Wisbit (mobile learning)', 'Geen live meetings'],
  template: {
    bits: [
      {
        title: 'Introductie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
        ],
      },
      {
        title: 'Voorkennis activeren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Instructie / Demonstratie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Opdracht',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Feedback',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
    ],
  },
};

const MLearning = {
  id: 'm-learning',
  name: 'M-learning',
  time: 'Vanaf 15 minuten',
  descriptions: ['Lange Wisbit (mobile learning)', 'Geen live meetings'],
  template: {
    bits: [
      {
        title: 'Introductie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
        ],
      },
      {
        title: 'Voorkennis activeren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Voorkennis activeren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Instructie / Demonstratie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Instructie / Demonstratie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Opdracht',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Terugblik',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Feedback',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
    ],
  },
};

const BlendedLearningJourney = {
  id: 'blended-learning-journey',
  name: 'Blended Leertraject',
  time: 'Vanaf 1 bijeenkomst',
  descriptions: ['Lange Wisbit (mobile learning)', 'Live meetings (groep)'],
  template: {
    bits: [
      {
        title: 'Introductie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
        ],
      },
      {
        title: 'Persoonlijk leerdoel formuleren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Voorkennis activeren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Voorkennis activeren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Instructie / Demonstratie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Instructie / Demonstratie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Opdracht',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Bijeenkomst',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.MEETING,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Opdracht',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Instructie / Demonstratie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Bijeenkomst',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.MEETING,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
        ],
      },
      {
        title: 'Terugblik',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
        ],
      },
      {
        title: 'Opdracht',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Feedback',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
    ],
  },
};

const BlendedGuidance = {
  id: 'blended-guidance',
  name: 'Blended Begeleiding',
  time: 'Vanaf 1 bijeenkomst',
  descriptions: [
    'Lange Wisbit (mobile learning)',
    'Live meetings (individueel)',
  ],
  template: {
    bits: [
      {
        title: 'Introductie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
        ],
      },
      {
        title: 'Persoonlijk leerdoel formuleren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Voorkennis activeren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Voorkennis activeren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Instructie / Demonstratie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Opdracht',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Bijeenkomst',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.MEETING,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Formatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Instructie / Demonstratie',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Opdracht',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Bijeenkomst',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.MEETING,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
        ],
      },
      {
        title: 'Terugblik',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
        ],
      },
      {
        title: 'Opdracht',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.IMAGE,
          },
          {
            type: COMPONENT_TYPES.TEXT,
          },
          {
            type: COMPONENT_TYPES.LINK,
          },
          {
            type: COMPONENT_TYPES.VIDEO,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.MULTIPLE_CHOICES,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Summatief evalueren',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
      {
        title: 'Feedback',
        components: [
          {
            type: COMPONENT_TYPES.TEXT,
            value: 'Tekst van de vraag',
          },
          {
            type: COMPONENT_TYPES.OPEN_QUESTION,
          },
        ],
      },
    ],
  },
};

const templates = [
  Microlearning,
  MLearning,
  BlendedLearningJourney,
  BlendedGuidance,
];

export default templates;
